import React from 'react';
import CommonTextInput from '../../../Common/Controller/Text';
import {
  handleInputChange,
  handleUpperInputBlur,
} from '../../../../util/Safety/DamageReport/Handler/changedInputHandler';

const EquipmentInfoFields = ({ isCompleted, damageReport, isEditable }) => {
  return (
    <div className="flex gap-x-[8px] mt-[16px]">
      <div className="w-[219px]">
        <CommonTextInput
          label="EQUIPMENT"
          inputName="cont_no"
          placeholder="CONT / TRAILER #"
          disabled={isCompleted || !isEditable}
          onChangeHandler={handleInputChange}
          onBlurHandler={handleUpperInputBlur}
          defaultValue={damageReport?.cont_no || ''}
        />
      </div>
      <div className="w-[219px]">
        <CommonTextInput
          label="SEAL #"
          inputName="cont_seal"
          disabled={isCompleted || !isEditable}
          maxLength={20}
          onChangeHandler={handleInputChange}
          defaultValue={damageReport?.cont_seal || ''}
        />
      </div>
    </div>
  );
};

export default EquipmentInfoFields;
